import { Colors, FontWeight, Breakpoints } from '../../assets/styles';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(()=>({
    containerColumn: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      margin: '0 16px',
      maxWidth: '100vw',
      minHeight: '100vh',
      overflow: 'hidden',
      padding: 0,
    },
    forgotRoot: {
      minHeight: '100vh',
      backgroundColor: Colors.White,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    main: {
      maxWidth: 500,
      margin: 'auto',
      paddingTop: 10,
    },
    zeroLogo: {
      display: 'block',
      margin: '0 auto',
      marginBottom: 32,
      height: 'auto',
      maxWidth: 300,
    },
    title: {
      textAlign: 'center',
      fontSize: 36,
      fontWeight: FontWeight.Bold,
      color: Colors.Blue,
       marginBottom: '24px !important',
      // [theme.breakpoints.down(Breakpoints.XS)]: {
      //   fontSize: 36 * 0.7,
      // },
    },
    note: {
      fontSize: 18,
      textAlign: 'center',
      marginBottom: 40,
      fontWeight: FontWeight.Light,
      color: Colors.Gray4,
    },
    inputMail: {
      marginBottom: '50px !important',
    },
    loginLinkContainer: {
      marginTop: 50,
      textAlign: 'center',
    },
    loginLink: {
      fontWeight: FontWeight.Light,
      fontSize: 15,
      color: Colors.Blue1,
      textDecoration: 'none',
    },
    submitButtonStyles: {
      width: 280,
      display: 'block !important',
      margin: '0 auto !important',
    },
  })
);

export default useStyles;
